import React, { useState, useEffect } from 'react';
import { UrbanZaikhaLogo } from './Logo';
import { getRandomProductImage } from '../utils/images';

const Hero: React.FC = () => {
  const [heroImage, setHeroImage] = useState<string>('');

  // Set the hero image only once when component mounts
  useEffect(() => {
    setHeroImage(getRandomProductImage());
  }, []);

  const scrollToMenu = () => {
    document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center text-center text-white overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-60 z-10"></div>
      <img
        src={heroImage} // Use the stable hero image
        alt="Delicious Urban Zaikha dish"
        className="absolute inset-0 w-full h-full object-cover animate-[zoom_20s_ease-in-out_infinite]"
        style={{ animationName: 'zoom' }}
      />
      <style>{`
        @keyframes zoom {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>

      <div className="relative z-20 p-8 flex flex-col items-center">
        <UrbanZaikhaLogo size="hero" className="mb-4" />
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-[#f0e1b2] leading-tight mb-4 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
          Modern Cravings, Desi Soul
        </h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto mb-8 text-gray-200 animate-fade-in-up" style={{ animationDelay: '1s' }}>
          Authentic Hyderabadi fusion cuisine delivered to your doorstep in the Dallas-Fort Worth metroplex.
        </p>
        <button
          onClick={scrollToMenu}
          className="bg-[#d4af37] text-[#0a3d34] font-bold py-3 px-8 rounded-full text-lg hover:bg-[#f0e1b2] transition-all duration-300 transform hover:scale-105 animate-fade-in-up"
          style={{ animationDelay: '1.5s' }}
        >
          Explore The Menu
        </button>
      </div>
       <style>{`
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
};

export default Hero;
